__turbopack_context__.v({
  "collectedAccordionBody": "UserPageStats-module-scss-module__LaOYXq__collectedAccordionBody",
  "collectedAccordionButton": "UserPageStats-module-scss-module__LaOYXq__collectedAccordionButton",
  "collectedAccordionTable": "UserPageStats-module-scss-module__LaOYXq__collectedAccordionTable",
  "scrollContainer": "UserPageStats-module-scss-module__LaOYXq__scrollContainer",
});
